
















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
})
export default class LoaderWrapper extends Vue {
}
